import {
  myStageTokenCookieName,
  myStageRefreshTokenCookieName,
  myStageServiceIdCookieName,
  myStageStudentTokenCookieName
} from '@/utils/constants';
import Cookies from 'js-cookie';

function saveMyStageLoginCookies(data) {
  const {
    mystage_token: myStageToken,
    mystage_refresh_token: myStageRefreshToken,
    mystage_service_id: serviceId,
    access_token_expires_at: accessTokenExpiresAt,
    refresh_token_expires_at: refreshTokenExpiresAt,
    mystage_student_token: myStageStudentToken
  } = data;

  if (!myStageToken || !myStageRefreshToken || !serviceId) {
    throw new Error('Missing login info');
  }

  const accessTokenExpireDays = new Date(accessTokenExpiresAt);
  const refreshTokenExpireDays = new Date(refreshTokenExpiresAt);

  /**
   * Determines the correct cookie domain for creation or deletion based on the current environment
   * - Local: If running on a local subdomain use `.bizmates.jp.local` so cookies are shared across local subdomains.
   * - Prod: If running on any bizmates.jp subdomain, use `.bizmates.jp`.
   * - Others: For localhost or non-bizmates domains, use undefined (scoped to current host).
   */
  const hostname = window.location.hostname;
  const cookieDomain = hostname.includes('bizmates.jp.local')
    ? '.bizmates.jp.local'
    : hostname.endsWith('bizmates.jp')
      ? '.bizmates.jp'
      : undefined;

  Cookies.set(myStageTokenCookieName, myStageToken, {
    secure: true,
    sameSite: 'Strict',
    expires: accessTokenExpireDays,
    domain: cookieDomain
  });

  Cookies.set(myStageRefreshTokenCookieName, myStageRefreshToken, {
    secure: true,
    sameSite: 'Strict',
    expires: refreshTokenExpireDays,
    domain: cookieDomain
  });

  Cookies.set(myStageServiceIdCookieName, serviceId, {
    secure: true,
    sameSite: 'Strict',
    expires: refreshTokenExpireDays,
    domain: cookieDomain
  });

  if (myStageStudentToken) {
    Cookies.set(myStageStudentTokenCookieName, myStageStudentToken, {
      secure: true,
      sameSite: 'Strict',
      expires: accessTokenExpireDays,
      domain: cookieDomain
    });
  } else if (myStageStudentToken === null) {
    const existingStudentToken = Cookies.get(myStageStudentTokenCookieName);
    if (existingStudentToken) {
      Cookies.remove(myStageStudentTokenCookieName, { domain: cookieDomain, path: '/' });
    }
  }
}

function getMyStageToken() {
  return Cookies.get(myStageTokenCookieName);
}

function getMyStageRefreshToken() {
  return Cookies.get(myStageRefreshTokenCookieName);
}

function getServiceId() {
  return Cookies.get(myStageServiceIdCookieName);
}

export { saveMyStageLoginCookies, getMyStageToken, getMyStageRefreshToken, getServiceId };
